import React from "react";
import { useTranslation } from "react-i18next";
import "./style.css";

const SimpleTable = ({ data }) => {
    const { t } = useTranslation();

    if (!data || data.length == 0) {
        return <p>{t("No data available")}</p>;
    }

    const headers = Object.keys(data[0]);

    return (
        <table className="custom-table simple-table">
            <thead>
                <tr>
                    {headers.map((key, index) => (
                        <th key={index}>{t(`properties.${key}`)}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {headers.map((key, colIndex) => (
                            <td key={colIndex}>
                                {row[key] !== null && row[key] !== undefined
                                    ? typeof row[key] === "object"
                                        ? JSON.stringify(row[key])
                                        : row[key]
                                    : "-"}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default SimpleTable;
